export const formatPrice = (
  price: number | string | null | undefined
): string => {
  if (price === null || price === undefined) {
    return "";
  }
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
